import { useQuery } from "@tanstack/react-query";
import type { Home } from "@hik/contracts";
import { get } from "../../lib/api";

export const useHome = (enabled = true) =>
  useQuery({ queryKey: ["home"], queryFn: () => get<Home>("/home"), enabled, refetchInterval: 120_000 });

/** Gezinme rozetleri ana ekran verisinden türetilir (ek istek yok). */
export function badgeCounts(home: Home | undefined) {
  const a = home?.actions ?? [];
  return {
    approvals: a.filter((x) => x.kind.startsWith("approve_")).length,
    tasks: a.filter((x) => x.kind === "task").length,
    documents: a.filter((x) => x.kind === "document_request").length,
  };
}
